export const pricingI18NDe = {
    hourlyRateFormat: (rate: number, currency: string) =>
        `${currency} ${rate}/Std.`,
    monthlyRateFormat: (rate: number, currency: string) =>
        `${currency} ${rate}/Monat`,
    noValuePlaceholder: "-",
};
